import { Visible, Hidden } from '@leroy-merlin-br/backyard-react-ui'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import { Desktop, Mobile } from './CartEmpty'

const CartEmpty = () => {
  return <div>
    <ContextVisibility when={['ecommerce']}>
      <Hidden untilKilo kilo>
        <Desktop />
      </Hidden>
    </ContextVisibility>

    <ContextVisibility when={['app', 'ecommerce']}>
      <Visible untilKilo kilo>
        <Mobile />
      </Visible>
    </ContextVisibility>
  </div>
}

export default CartEmpty
